import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { fetchSites, fetchSiteDetail, SiteSummary, SiteDetail } from '../../services/api';

export interface SitesState {
  sites: SiteSummary[];
  selectedSiteDetail: SiteDetail | null;
  loading: boolean;
  error: string | null;
}

const initialState: SitesState = {
  sites: [],
  selectedSiteDetail: null,
  loading: false,
  error: null,
};

// Async thunks
export const loadSites = createAsyncThunk('sites/loadSites', async () => {
  return fetchSites();
});

export const loadSiteDetail = createAsyncThunk(
  'sites/loadSiteDetail',
  async (siteId: string) => {
    return fetchSiteDetail(siteId);
  }
);

const sitesSlice = createSlice({
  name: 'sites',
  initialState,
  reducers: {
    clearSelectedSite: (state) => {
      state.selectedSiteDetail = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // loadSites
      .addCase(loadSites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadSites.fulfilled, (state, action: PayloadAction<SiteSummary[]>) => {
        state.sites = action.payload;
        state.loading = false;
      })
      .addCase(loadSites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to load sites';
      })
      // loadSiteDetail
      .addCase(loadSiteDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadSiteDetail.fulfilled, (state, action: PayloadAction<SiteDetail>) => {
        state.selectedSiteDetail = action.payload;
        state.loading = false;
      })
      .addCase(loadSiteDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to load site detail';
      });
  },
});

export const { clearSelectedSite, clearError } = sitesSlice.actions;
export default sitesSlice.reducer;
